import { TriangleDownIcon } from "@chakra-ui/icons";
import { Flex, Text, Tooltip } from "@chakra-ui/react";
import { Marker as MapboxMarker } from "react-map-gl";
import { Coordinate } from "~/generated/graphql.types";

export const HyperlapseSpotMarker = ({
  coordinate,
  label,
  onDragEnd,
}: {
  coordinate: Coordinate;
  label: string;
  onDragEnd: (coord: Coordinate) => void;
}) => {
  return (
    <MapboxMarker
      latitude={coordinate.lat}
      longitude={coordinate.lon}
      draggable={true}
      onDragEnd={(e) => {
        onDragEnd({
          lat: e.lngLat.lat,
          lon: e.lngLat.lng,
        });
      }}
    >
      <Flex
        w={4}
        h={4}
        rounded="full"
        bgColor="#3D6BAB"
        borderWidth={5}
        borderColor="#3D6BAB"
        justifyContent="center"
      >
        <TriangleDownIcon
          position="absolute"
          zIndex={-1}
          bottom={-2}
          color={"black"}
          fontSize={16}
        />
        <Text
          fontWeight={400}
          lineHeight={0.4}
          color={undefined}
          fontSize={"sm"}
        >
          {label}
        </Text>
      </Flex>
    </MapboxMarker>
  );
};
